/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// ILLUSTRATION : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	illustration: {
		backgroundColor: 'transparent',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'contain',
		display: 'block',

		'&.name-placeholder': {
			backgroundImage: `url(${url.image.app}/graphic-placeholder.png)`,
			width: pxToEm(125),
			height: pxToEm(100)
		},
		'&.name-error-404': {
			backgroundImage: `url(${url.image.app}/illustration-404.svg)`,
			width: pxToEm(330),
			height: pxToEm(283)
		},
		'&.name-error-500, &.name-error-403': {
			backgroundImage: `url(${url.image.app}/illustration-500.svg)`,
			width: pxToEm(235),
			height: pxToEm(261)
		},
		'&.name-insight': {
			backgroundImage: `url(${url.image.app}/illustration-notification-insight.svg)`,
			width: pxToEm(200),
			height: pxToEm(200)
		},
		'&.name-paintbrush': {
			backgroundImage: `url(${url.image.app}/illustration-empty-embed.svg)`,
			width: pxToEm(124),
			height: pxToEm(198)
		},
		'&.name-embed': {
			backgroundImage: `url(${url.image.app}/embed-layout-large-pic-active.png)`,
			width: pxToEm(140),
			height: pxToEm(140)
		},
		'&.name-email': {
			backgroundImage: `url(${url.image.app}/illustration-email.svg)`,
			width: pxToEm(131),
			height: pxToEm(171)
		},
		'&.name-payment': {
			backgroundImage: `url(${url.image.app}/illustration-payment.svg)`,
			width: pxToEm(150),
			height: pxToEm(153)
		},
		'&.name-mobile': {
			backgroundImage: `url(${url.image.app}/mks/graphic-placement-mobile-blank-large.png)`,
            height:pxToEm(380),
            width:pxToEm(210)
        },
        '&.name-desktop': {
			backgroundImage: `url(${url.image.app}/mks/graphic-placement-rail-large.png)`,
            width: pxToEm(673),
            height: pxToEm(443)
        },
		// insticator (icon only)
		'&.name-insticator-icon': {
			backgroundImage: `url(${url.image.app}/logo-insticator-icon.svg)`,
			backgroundPosition: '50%',
			height: pxToEm(130),
			width: pxToEm(130)
		}
	}
});